import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { ApplicationState, AppState } from '../../../store';
import { withSnackbar, ProviderContext } from 'notistack';
import { ITranslatorService } from '../../../services/Interfaces/ITranslatorService';
import { ApplicationContext, AppContext } from '../../../context/Contexts';
import {
  Tooltip,
  Box,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  Grid,
  Typography,
  DialogContent
} from '@material-ui/core';
import { ScaleLoader } from 'react-spinners';
import AddCircleTwoToneIcon from '@material-ui/icons/AddCircleTwoTone';
import { RouteComponentProps } from 'react-router';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MUIDataTable, {
  SelectableRows,
  MUIDataTableMeta,
  MUIDataTableColumnOptions
} from 'mui-datatables';
import { MUITranslations } from '../../../helpers/MUITableTranslations';
import CloseIcon from '@material-ui/icons/Close';
import DeleteOutlineTwoToneIcon from '@material-ui/icons/DeleteOutlineTwoTone';
import { IReferential } from '../../../interfaces/IReferential';
import moment from 'moment';
import { IReferentialService } from '../../../services/Interfaces/IReferentialService';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import {  DealerStartStock, Organization } from '../../../interfaces/Organization';
import { IOrganizationService } from '../../../services/Interfaces/IOrganizationService';
import NumberFormat from 'react-number-format';

interface IDealerStartStockComponentState {
  newDealerStartStock: DealerStartStock;
  dealerStartStocks: DealerStartStock[];
  isLoading: boolean;
  isDialogOpen: boolean;
  newDealerStartStockId: number | null;
  organizationList: Organization[];
}
type IDealerStartStockComponentProps = { appState: AppState } & ProviderContext &
  RouteComponentProps<{ id: string; workflowId: string }>;
class DealerStartStockComponent extends React.PureComponent<
  IDealerStartStockComponentProps,
  IDealerStartStockComponentState
> {
  private translatorService!: ITranslatorService;
  private organizationService!: IOrganizationService;
  static contextType = ApplicationContext;
  private newDealerStartStock = {
    id: 0,
    organizationId: 0
  } as DealerStartStock;

  state = {
    isLoading: false,
    isDialogOpen: false,
    newDealerStartStock: this.newDealerStartStock,
    dealerStartStocks: [],
    newDealerStartStockId: null,
    organizationList: []
  } as IDealerStartStockComponentState;

  public componentDidMount() {
    this.setState(
      {
        isLoading: true
      },
      async () => {
        await this.loadDealerStartStocks();
      }
    );
  }

  loadDealerStartStocks = async () => {
    const [dealerStartStocks, organizations] = await Promise.all([
      this.organizationService.GetDealerStartStocks(true),
      this.organizationService.GetMvoOrganizations()
    ]);

    this.setState({
      dealerStartStocks: dealerStartStocks,
      isLoading: false,
      newDealerStartStock: { ...this.newDealerStartStock },
      organizationList: organizations
    });
  };

  private handleOrganizationChange = (newValue: Organization | null) => {
    this.setState({
      newDealerStartStock: {
        ...this.state.newDealerStartStock,
        organization: newValue,
        organizationId: newValue !== null ? newValue!.id : 0
      }
    });
  };

  private handleValueChange = (value: string) => {
    this.setState({
      newDealerStartStock: {
        ...this.state.newDealerStartStock,
        value: parseFloat(value)
      }
    });
  };

  public saveDealerStartStock = async () => {
    if (this.state.newDealerStartStockId === null) {
      if (
        this.state.dealerStartStocks.findIndex(
          (item) => item.organizationId === this.state.newDealerStartStock.organizationId
        ) !== -1
      ) {
        this.props.enqueueSnackbar(
          this.translatorService.Tranlate(
            'DEALER_START_STOCK_ALREADY_EXIST',
            'Exista deja un stoc!'
          ),
          { variant: 'error' }
        );
        return;
      }
      try {
        await this.organizationService.AddDealerStartStock(this.state.newDealerStartStock);
        await this.loadDealerStartStocks();
        this.closeDialog();
        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    } else {
      try {
        await this.organizationService.UpdateDealerStartStock(this.state.newDealerStartStock);
        await this.loadDealerStartStocks();
        this.closeDialog();
        this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
          variant: 'success'
        });
      } catch (error) {
        this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
          variant: 'error'
        });
      }
    }
  };

  NumberFormatCustom = (props: any) => {
    const { inputRef, onChange, ...other } = props;
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values: any) => {
          onChange({
            target: {
              value: values.value
            },
            currentTarget: {
              value: values.value
            }
          });
        }}
        allowNegative={false}
        thousandSeparator={false}
        decimalScale={2}
      />
    );
  };

  public renderAddForm() {
    return (
      <ValidatorForm onSubmit={this.saveDealerStartStock} instantValidate={true}>
        <Box mb={2}>
          <Autocomplete
            id="org"
            size="small"
            fullWidth
            options={this.state.organizationList.sort(function (a, b) {
              return a!.displayName.localeCompare(b!.displayName);
            })}
            value={this.state.newDealerStartStock.organization}
            onChange={(e: any, newValue: Organization | null) =>
              this.handleOrganizationChange(newValue)
            }
            getOptionLabel={(option: Organization) => option!.displayName || ''}
            renderInput={(params) => (
              <TextValidator
                {...params}
                name="org"
                value={this.state.newDealerStartStock.organization}
                label={this.translatorService.Tranlate(
                  'VEHICLES_VEHICLE_ORGANIZATION',
                  'Organizatie'
                )}
                fullWidth
                validators={['required']}
                errorMessages={[
                  this.translatorService.Tranlate(
                    'VALIDATORS_REQUIRED',
                    'Campul este obligatoriu'
                  )
                ]}
              />
            )}
          />
        </Box>

        <Box mb={2}>
          <TextValidator
            fullWidth
            name="value"
            id="value"
            value={this.state.newDealerStartStock.value || ''}
            onChange={(e: any) => this.handleValueChange(e.target.value)}
            label={this.translatorService.Tranlate(
              'DEALER_START_STOCK_VALUE',
              'Stock de start'
            )}
            validators={['required', 'minNumber:0']}
            errorMessages={[
              this.translatorService.Tranlate('VALIDATORS_REQUIRED', 'Campul este obligatoriu')
            ]}
            InputProps={{
              inputComponent: this.NumberFormatCustom
            }}
          />
        </Box>

        <div className="text-right">
          <Button
            className="m-2"
            variant="outlined"
            color="default"
            onClick={this.closeDialog}
          >
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_CANCEL_BTN', 'Anuleaza')}
          </Button>
          <Button className="m-2" variant="contained" color="secondary" type="submit">
            {this.translatorService.Tranlate('EDIT_ORGANIZATION_SAVE_BTN', 'Salveaza')}
          </Button>
        </div>
    </ValidatorForm>
    );
  }
  getColumns = () => {
    const columns = [
      {
        name: 'id',
        options: { display: 'excluded', filter: false } as MUIDataTableColumnOptions
      },
      {
        name: 'organization',
        label: this.translatorService.Tranlate('VEHICLES_VEHICLE_ORGANIZATION', 'Organizatie'),
        options: {
          sort: true,
          customSort: (a: Organization, b: Organization) => {
            debugger;
            return a.name!.localeCompare(b.name!);
          },
          customBodyRender: (value: Organization) => {
            return value ? value.displayName : '';
          }
        } as MUIDataTableColumnOptions
      },
      {
        name: 'value',
        label: this.translatorService.Tranlate(
          'DEALER_START_STOCK_VALUE',
          'Stock de start'
        )
      },
      {
        name: 'dateModification',
        label: this.translatorService.Tranlate('USERS_DATE_MODIFICATION_HEADER', 'Data Modificare'),
        options: {
          filter: false,
          sortDirection: 'desc',
          customBodyRender: (value: Date) =>
            moment.utc(value).local().format(this.props.appState.longDateFormat)
        } as MUIDataTableColumnOptions
      },
      {
        name: '',
        options: {
          viewColumns: false,
          filter: false,
          setCellHeaderProps: () => ({ align: 'center' }),
          setCellProps: () => ({ align: 'center' }),
          customBodyRender: (value: boolean, tableMeta: MUIDataTableMeta) => {
            return (
              <>
                <IconButton
                  aria-label="edit"
                  color="primary"
                  className="text-primary"
                  size="small"
                  onClick={(e) => this.newDealerStartStockPopup(tableMeta.rowData[0])}
                >
                    <EditOutlinedIcon />
                </IconButton>
                <IconButton
                  aria-label="delete"
                  color="inherit"
                  className="text-danger"
                  size="small"
                  onClick={(e) => this.deleteDealerStartStock(e, tableMeta)}
                >
                  <DeleteOutlineTwoToneIcon />
                </IconButton>
              </>
            );
          }
        }
      }];
    return columns;
  };

  deleteDealerStartStock = async (event: any, tableMeta: MUIDataTableMeta) => {
    try {
      const id = tableMeta.rowData[0];
      await this.organizationService.RemoveDealerStartStock(id);
      await this.loadDealerStartStocks();
      this.props.enqueueSnackbar(this.translatorService.Tranlate('SUCCES_MSG', 'OK'), {
        variant: 'success'
      });
    } catch (error) {
      this.props.enqueueSnackbar(this.translatorService.Tranlate('ERROR_MSG', 'Eroare'), {
        variant: 'error'
      });
    }
  };

  newDealerStartStockPopup = async (dealerStartStockId: number | null) => {
    let newDealerStartStock: DealerStartStock;
    if (dealerStartStockId == null) {
      newDealerStartStock = { ...this.state.newDealerStartStock } as DealerStartStock;
    } else {
      newDealerStartStock = this.state.dealerStartStocks.find((item) => item.id === dealerStartStockId)!;
    }
    this.setState({
      isDialogOpen: true,
      newDealerStartStock: newDealerStartStock,
      newDealerStartStockId: dealerStartStockId
    });
  };

  closeDialog = async () => {
    this.setState(
      { 
        isDialogOpen: false, 
        newDealerStartStock: this.newDealerStartStock 
      }
    );
  };

  public render() {
    this.translatorService = (this.context as AppContext).translatorService;
    this.organizationService = (this.context as AppContext).organizationService;
    const options = {
      filter: true,
      selectableRows: 'none' as SelectableRows,
      selectableRowsOnClick: false,
      print: false,
      download: false,
      textLabels: MUITranslations.GetTranslations(this.translatorService),
      sort: false,
      // responsive: "stacked",
      customToolbar: () => {
        return (
          <Tooltip title={this.translatorService.Tranlate('Add', 'Adauga')}>
            <IconButton
              aria-label="add"
              color="secondary"
              className="m-2"
              onClick={(e) => this.newDealerStartStockPopup(null)}
            >
              <AddCircleTwoToneIcon />
            </IconButton>
          </Tooltip>
        );
      }
    };
    return (
      <Fragment>
    
       <Box mt={1} pt={1}>
          <div className="d-flex flex-row text-center flex-wrap justify-content-center">
            <ScaleLoader color={'var(--primary)'} loading={this.state.isLoading} />
          </div>
          {!this.state.isLoading ? (
            <MUIDataTable
              title={''}
              data={this.state.dealerStartStocks}
              columns={this.getColumns()}
              options={options}
            />
          ) : null}
        </Box>
        {this.state.isDialogOpen ? (
          <Dialog
            onClose={this.closeDialog}
            aria-labelledby="customized-dialog-title"
            open={this.state.isDialogOpen}
            fullWidth={true}
            maxWidth={'sm'}
          >
            <DialogTitle id="customized-dialog-title">
              <Grid container>
                <Grid item xs={11}>
                  <Typography variant="h4">
                  {!this.state.newDealerStartStockId ? 
                    this.translatorService.Tranlate(
                      'DEALER_START_STOCK_ADD_MODAL_TITLE',
                      'Adauga stock start'
                    ) : this.translatorService.Tranlate(
                      'DEALER_START_STOCK_UPDATE_MODAL_TITLE',
                      'Actualizeaza stock start'
                    )}               
                  </Typography>
                </Grid>
                <Grid item xs={1}>
                  <IconButton aria-label="close" onClick={this.closeDialog} size={'small'}>
                    <CloseIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </DialogTitle>
            <DialogContent dividers>{this.renderAddForm()}</DialogContent>
          </Dialog>) : null}
      </Fragment>
    );
  }
}
export default connect(
  (state: ApplicationState) => ({
    appState: state.app
  }),
  null
)(withSnackbar(DealerStartStockComponent as any));